import type {ReactElement} from 'react';
import React from 'react';
import type {StockFilterID} from '@Panels/stock-panel/stock-panel.types';
import type {StockFilterListItem} from '@Panels/stock-panel/components/stock-filter-button/stock-filter-button.types';
import {PillButton} from '@Components/pill-button';
import type {PillButtonSize} from '@Components/pill-button/pill-button.types';
import styles from './stock-filter-pill-button.module.scss';

export interface StockFilterPillButtonProps {
  id: StockFilterID;
  subfilters: Array<StockFilterListItem>;
  selectedSubfilterID?: string;
  pillSize: PillButtonSize;
  onSubFilterClicked(filterID: StockFilterID, subFilterID?: string): void;
  className?: string;
}

export function StockFilterPillButton({...props}: StockFilterPillButtonProps): ReactElement | null {
  const selectedItemID = props.selectedSubfilterID
    ? props.subfilters.find((subfilter) => {
        return subfilter.id === props.selectedSubfilterID;
      })?.id
    : undefined;

  return (
    <ul className={`flex-h-row spacing-m-0 ${styles.filtersList} ${props.className ?? ''}`}>
      {props.subfilters.map((subfilter) => {
        return (
          <li key={subfilter.id} className="spacing-p-0 _full-height _full-width">
            {subfilter.id === selectedItemID ? (
              <PillButton
                isSelected
                size={props.pillSize}
                text={subfilter.text}
                onClick={() => {}}
                onClose={() => {
                  props.onSubFilterClicked(props.id);
                }}
              />
            ) : (
              <PillButton
                size={props.pillSize}
                text={subfilter.text}
                onClick={() => {
                  props.onSubFilterClicked(props.id, subfilter.id);
                }}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
}
